import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Hero() {
  return <section className="relative w-full min-h-screen bg-[#0B1C2C] overflow-hidden" data-id="element-91">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0E2238]/50 to-[#0B1C2C]" data-id="element-92"></div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 pb-32" data-id="element-93">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center min-h-[calc(100vh-8rem)]" data-id="element-94">
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="text-center lg:text-left" data-id="element-95">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2,
            duration: 0.6
          }} className="inline-block mb-6" data-id="element-96">
              <span className="px-4 py-2 bg-[#2F6BFF]/20 border border-[#2F6BFF]/50 rounded-full text-[#7EC8FF] text-sm font-semibold" data-id="element-97">
                🔬 Basado en Ciencia Real
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3,
            duration: 0.6
          }} className="text-4xl sm:text-5xl lg:text-6xl font-black text-[#F2F4F8] mb-6 leading-tight" data-id="element-98">
              El Manual Prohibido de la{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2F6BFF] to-[#7EC8FF]" data-id="element-99">
                Creatina
              </span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4,
            duration: 0.6
          }} className="text-xl sm:text-2xl text-[#F2F4F8]/80 mb-4 font-medium" data-id="element-100">
              Todo Lo Que Las Marcas No Te Cuentan
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.5,
            duration: 0.6
          }} className="text-lg text-[#F2F4F8]/70 mb-8 max-w-xl mx-auto lg:mx-0" data-id="element-101">
              Descubre la verdad sobre la creatina que la industria no quiere
              que sepas. Ahorra miles de pesos y obtén resultados reales.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.6,
            duration: 0.6
          }} className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-102">
              <CTAButton size="large" data-id="element-103">Obtener Acceso Inmediato →</CTAButton>
            </motion.div>

            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.8,
            duration: 0.6
          }} className="mt-8 flex items-center justify-center lg:justify-start gap-6 text-sm text-[#F2F4F8]/60" data-id="element-104">
              <div className="flex items-center gap-2" data-id="element-105">
                <span className="text-green-400" data-id="element-106">✓</span>
                <span data-id="element-107">Acceso instantáneo</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-108">
                <span className="text-green-400" data-id="element-109">✓</span>
                <span data-id="element-110">4 bonos incluidos</span>
              </div>
            </motion.div>
          </motion.div>

          {/* RIGHT COLUMN - PRODUCT MOCKUP */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.85
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          delay: 0.4,
          duration: 0.8,
          ease: 'easeOut'
        }} className="relative flex justify-center items-center" data-id="element-111">
            <motion.div animate={{
            y: [0, -10, 0, -10, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-112">
              <img src="https://cdn.magicpatterns.com/uploads/kZ5LW9E84VPVVFeSY6ZZQT/Untitled_design-2.png" alt="El Manual Prohibido de la Creatina - Pack completo con bonos" className="w-full max-w-lg mx-auto drop-shadow-2xl" style={{
              filter: 'drop-shadow(0 25px 50px rgba(47, 107, 255, 0.35))'
            }} data-id="element-113" />
            </motion.div>
          </motion.div>
        </div>
      </div>

      
    </section>;
}